// Country centers for the traffic map. Names come from Intl.DisplayNames.
export const COUNTRY_POINTS: Record<string, { lat: number; lon: number }> = {
  AW: { lat: 12.5, lon: -69.9667 },
  AF: { lat: 33.0, lon: 65.0 },
  AO: { lat: -12.5, lon: 18.5 },
  AI: { lat: 18.25, lon: -63.1667 },
  AX: { lat: 60.1167, lon: 19.9 },
  AL: { lat: 41.0, lon: 20.0 },
  AD: { lat: 42.5, lon: 1.5 },
  AE: { lat: 24.0, lon: 54.0 },
  AR: { lat: -34.0, lon: -64.0 },
  AM: { lat: 40.0, lon: 45.0 },
  AS: { lat: -14.3333, lon: -170.0 },
  AQ: { lat: -90.0, lon: 0.0 },
  TF: { lat: -49.25, lon: 69.167 },
  AG: { lat: 17.05, lon: -61.8 },
  AU: { lat: -27.0, lon: 133.0 },
  AT: { lat: 47.3333, lon: 13.3333 },
  AZ: { lat: 40.5, lon: 47.5 },
  BI: { lat: -3.5, lon: 30.0 },
  BE: { lat: 50.8333, lon: 4.0 },
  BJ: { lat: 9.5, lon: 2.25 },
  BF: { lat: 13.0, lon: -2.0 },
  BD: { lat: 24.0, lon: 90.0 },
  BG: { lat: 43.0, lon: 25.0 },
  BH: { lat: 26.0, lon: 50.55 },
  BS: { lat: 24.25, lon: -76.0 },
  BA: { lat: 44.0, lon: 18.0 },
  BL: { lat: 18.5, lon: -63.4167 },
  SH: { lat: -15.95, lon: -5.72 },
  BY: { lat: 53.0, lon: 28.0 },
  BZ: { lat: 17.25, lon: -88.75 },
  BM: { lat: 32.3333, lon: -64.75 },
  BO: { lat: -17.0, lon: -65.0 },
  BQ: { lat: 12.18, lon: -68.25 },
  BR: { lat: -10.0, lon: -55.0 },
  BB: { lat: 13.1667, lon: -59.5333 },
  BN: { lat: 4.5, lon: 114.6667 },
  BT: { lat: 27.5, lon: 90.5 },
  BV: { lat: -54.4333, lon: 3.4 },
  BW: { lat: -22.0, lon: 24.0 },
  CF: { lat: 7.0, lon: 21.0 },
  CA: { lat: 60.0, lon: -95.0 },
  CC: { lat: -12.5, lon: 96.8333 },
  CH: { lat: 47.0, lon: 8.0 },
  CL: { lat: -30.0, lon: -71.0 },
  CN: { lat: 35.0, lon: 105.0 },
  CI: { lat: 8.0, lon: -5.0 },
  CM: { lat: 6.0, lon: 12.0 },
  CD: { lat: 0.0, lon: 25.0 },
  CG: { lat: -1.0, lon: 15.0 },
  CK: { lat: -21.2333, lon: -159.7667 },
  CO: { lat: 4.0, lon: -72.0 },
  KM: { lat: -12.1667, lon: 44.25 },
  CV: { lat: 16.0, lon: -24.0 },
  CR: { lat: 10.0, lon: -84.0 },
  CU: { lat: 21.5, lon: -80.0 },
  CW: { lat: 12.1167, lon: -68.9333 },
  CX: { lat: -10.5, lon: 105.6667 },
  KY: { lat: 19.5, lon: -80.5 },
  CY: { lat: 35.0, lon: 33.0 },
  CZ: { lat: 49.75, lon: 15.5 },
  DE: { lat: 51.0, lon: 9.0 },
  DJ: { lat: 11.5, lon: 43.0 },
  DM: { lat: 15.4167, lon: -61.3333 },
  DK: { lat: 56.0, lon: 10.0 },
  DO: { lat: 19.0, lon: -70.6667 },
  DZ: { lat: 28.0, lon: 3.0 },
  EC: { lat: -2.0, lon: -77.5 },
  EG: { lat: 27.0, lon: 30.0 },
  ER: { lat: 15.0, lon: 39.0 },
  EH: { lat: 24.5, lon: -13.0 },
  ES: { lat: 40.0, lon: -4.0 },
  EE: { lat: 59.0, lon: 26.0 },
  ET: { lat: 8.0, lon: 38.0 },
  FI: { lat: 64.0, lon: 26.0 },
  FJ: { lat: -18.0, lon: 175.0 },
  FK: { lat: -51.75, lon: -59.0 },
  FR: { lat: 46.0, lon: 2.0 },
  FO: { lat: 62.0, lon: -7.0 },
  FM: { lat: 6.9167, lon: 158.25 },
  GA: { lat: -1.0, lon: 11.75 },
  GB: { lat: 54.0, lon: -2.0 },
  GE: { lat: 42.0, lon: 43.5 },
  GG: { lat: 49.4667, lon: -2.5833 },
  GH: { lat: 8.0, lon: -2.0 },
  GI: { lat: 36.1333, lon: -5.35 },
  GN: { lat: 11.0, lon: -10.0 },
  GP: { lat: 16.25, lon: -61.5833 },
  GM: { lat: 13.4667, lon: -16.5667 },
  GW: { lat: 12.0, lon: -15.0 },
  GQ: { lat: 2.0, lon: 10.0 },
  GR: { lat: 39.0, lon: 22.0 },
  GD: { lat: 12.1167, lon: -61.6667 },
  GL: { lat: 72.0, lon: -40.0 },
  GT: { lat: 15.5, lon: -90.25 },
  GF: { lat: 4.0, lon: -53.0 },
  GU: { lat: 13.4667, lon: 144.7833 },
  GY: { lat: 5.0, lon: -59.0 },
  HK: { lat: 22.267, lon: 114.188 },
  HM: { lat: -53.1, lon: 72.5167 },
  HN: { lat: 15.0, lon: -86.5 },
  HR: { lat: 45.1667, lon: 15.5 },
  HT: { lat: 19.0, lon: -72.4167 },
  HU: { lat: 47.0, lon: 20.0 },
  ID: { lat: -5.0, lon: 120.0 },
  IM: { lat: 54.25, lon: -4.5 },
  IN: { lat: 20.0, lon: 77.0 },
  IO: { lat: -6.0, lon: 71.5 },
  IE: { lat: 53.0, lon: -8.0 },
  IR: { lat: 32.0, lon: 53.0 },
  IQ: { lat: 33.0, lon: 44.0 },
  IS: { lat: 65.0, lon: -18.0 },
  IL: { lat: 31.47, lon: 35.13 },
  IT: { lat: 42.8333, lon: 12.8333 },
  JM: { lat: 18.25, lon: -77.5 },
  JE: { lat: 49.25, lon: -2.1667 },
  JO: { lat: 31.0, lon: 36.0 },
  JP: { lat: 36.0, lon: 138.0 },
  KZ: { lat: 48.0, lon: 68.0 },
  KE: { lat: 1.0, lon: 38.0 },
  KG: { lat: 41.0, lon: 75.0 },
  KH: { lat: 13.0, lon: 105.0 },
  KI: { lat: 1.4167, lon: 173.0 },
  KN: { lat: 17.3333, lon: -62.75 },
  KR: { lat: 37.0, lon: 127.5 },
  XK: { lat: 42.6667, lon: 21.1667 },
  KW: { lat: 29.5, lon: 45.75 },
  LA: { lat: 18.0, lon: 105.0 },
  LB: { lat: 33.8333, lon: 35.8333 },
  LR: { lat: 6.5, lon: -9.5 },
  LY: { lat: 25.0, lon: 17.0 },
  LC: { lat: 13.8833, lon: -60.9667 },
  LI: { lat: 47.2667, lon: 9.5333 },
  LK: { lat: 7.0, lon: 81.0 },
  LS: { lat: -29.5, lon: 28.5 },
  LT: { lat: 56.0, lon: 24.0 },
  LU: { lat: 49.75, lon: 6.1667 },
  LV: { lat: 57.0, lon: 25.0 },
  MO: { lat: 22.1667, lon: 113.55 },
  MF: { lat: 18.0833, lon: -63.95 },
  MA: { lat: 32.0, lon: -5.0 },
  MC: { lat: 43.7333, lon: 7.4 },
  MD: { lat: 47.0, lon: 29.0 },
  MG: { lat: -20.0, lon: 47.0 },
  MV: { lat: 3.25, lon: 73.0 },
  MX: { lat: 23.0, lon: -102.0 },
  MH: { lat: 9.0, lon: 168.0 },
  MK: { lat: 41.8333, lon: 22.0 },
  ML: { lat: 17.0, lon: -4.0 },
  MT: { lat: 35.8333, lon: 14.5833 },
  MM: { lat: 22.0, lon: 98.0 },
  ME: { lat: 42.5, lon: 19.3 },
  MN: { lat: 46.0, lon: 105.0 },
  MP: { lat: 15.2, lon: 145.75 },
  MZ: { lat: -18.25, lon: 35.0 },
  MR: { lat: 20.0, lon: -12.0 },
  MS: { lat: 16.75, lon: -62.2 },
  MQ: { lat: 14.6667, lon: -61.0 },
  MU: { lat: -20.2833, lon: 57.55 },
  MW: { lat: -13.5, lon: 34.0 },
  MY: { lat: 2.5, lon: 112.5 },
  YT: { lat: -12.8333, lon: 45.1667 },
  NA: { lat: -22.0, lon: 17.0 },
  NC: { lat: -21.5, lon: 165.5 },
  NE: { lat: 16.0, lon: 8.0 },
  NF: { lat: -29.0333, lon: 167.95 },
  NG: { lat: 10.0, lon: 8.0 },
  NI: { lat: 13.0, lon: -85.0 },
  NU: { lat: -19.0333, lon: -169.8667 },
  NL: { lat: 52.5, lon: 5.75 },
  NO: { lat: 62.0, lon: 10.0 },
  NP: { lat: 28.0, lon: 84.0 },
  NR: { lat: -0.5333, lon: 166.9167 },
  NZ: { lat: -41.0, lon: 174.0 },
  OM: { lat: 21.0, lon: 57.0 },
  PK: { lat: 30.0, lon: 70.0 },
  PA: { lat: 9.0, lon: -80.0 },
  PN: { lat: -25.0667, lon: -130.1 },
  PE: { lat: -10.0, lon: -76.0 },
  PH: { lat: 13.0, lon: 122.0 },
  PW: { lat: 7.5, lon: 134.5 },
  PG: { lat: -6.0, lon: 147.0 },
  PL: { lat: 52.0, lon: 20.0 },
  PR: { lat: 18.25, lon: -66.5 },
  KP: { lat: 40.0, lon: 127.0 },
  PT: { lat: 39.5, lon: -8.0 },
  PY: { lat: -23.0, lon: -58.0 },
  PS: { lat: 31.9, lon: 35.2 },
  PF: { lat: -15.0, lon: -140.0 },
  QA: { lat: 25.5, lon: 51.25 },
  RE: { lat: -21.15, lon: 55.5 },
  RO: { lat: 46.0, lon: 25.0 },
  RU: { lat: 60.0, lon: 100.0 },
  RW: { lat: -2.0, lon: 30.0 },
  SA: { lat: 25.0, lon: 45.0 },
  SD: { lat: 15.0, lon: 30.0 },
  SN: { lat: 14.0, lon: -14.0 },
  SG: { lat: 1.3667, lon: 103.8 },
  GS: { lat: -54.5, lon: -37.0 },
  SJ: { lat: 78.0, lon: 20.0 },
  SB: { lat: -8.0, lon: 159.0 },
  SL: { lat: 8.5, lon: -11.5 },
  SV: { lat: 13.8333, lon: -88.9167 },
  SM: { lat: 43.7667, lon: 12.4167 },
  SO: { lat: 10.0, lon: 49.0 },
  PM: { lat: 46.8333, lon: -56.3333 },
  RS: { lat: 44.0, lon: 21.0 },
  SS: { lat: 7.0, lon: 30.0 },
  ST: { lat: 1.0, lon: 7.0 },
  SR: { lat: 4.0, lon: -56.0 },
  SK: { lat: 48.6667, lon: 19.5 },
  SI: { lat: 46.1167, lon: 14.8167 },
  SE: { lat: 62.0, lon: 15.0 },
  SZ: { lat: -26.5, lon: 31.5 },
  SX: { lat: 18.0333, lon: -63.05 },
  SC: { lat: -4.5833, lon: 55.6667 },
  SY: { lat: 35.0, lon: 38.0 },
  TC: { lat: 21.75, lon: -71.5833 },
  TD: { lat: 15.0, lon: 19.0 },
  TG: { lat: 8.0, lon: 1.1667 },
  TH: { lat: 15.0, lon: 100.0 },
  TJ: { lat: 39.0, lon: 71.0 },
  TK: { lat: -9.0, lon: -172.0 },
  TM: { lat: 40.0, lon: 60.0 },
  TL: { lat: -8.8333, lon: 125.9167 },
  TO: { lat: -20.0, lon: -175.0 },
  TT: { lat: 11.0, lon: -61.0 },
  TN: { lat: 34.0, lon: 9.0 },
  TR: { lat: 39.0, lon: 35.0 },
  TV: { lat: -8.0, lon: 178.0 },
  TW: { lat: 23.5, lon: 121.0 },
  TZ: { lat: -6.0, lon: 35.0 },
  UG: { lat: 1.0, lon: 32.0 },
  UA: { lat: 49.0, lon: 32.0 },
  UM: { lat: 19.3, lon: 166.6333 },
  UY: { lat: -33.0, lon: -56.0 },
  US: { lat: 38.0, lon: -97.0 },
  UZ: { lat: 41.0, lon: 64.0 },
  VA: { lat: 41.9, lon: 12.45 },
  VC: { lat: 13.25, lon: -61.2 },
  VE: { lat: 8.0, lon: -66.0 },
  VG: { lat: 18.4314, lon: -64.6231 },
  VI: { lat: 18.35, lon: -64.9333 },
  VN: { lat: 16.1667, lon: 107.8333 },
  VU: { lat: -16.0, lon: 167.0 },
  WF: { lat: -13.3, lon: -176.2 },
  WS: { lat: -13.5833, lon: -172.3333 },
  YE: { lat: 15.0, lon: 48.0 },
  ZA: { lat: -29.0, lon: 24.0 },
  ZM: { lat: -15.0, lon: 30.0 },
  ZW: { lat: -20.0, lon: 30.0 },
};
